import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LogAccessi } from 'src/app/models/log-accessi';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LogAccessiService {


  logAccessiUrl = environment.ildatoArticoliDpi + 'api/logaccessi';
  private http = inject(HttpClient);

  list(daData: Date | null = null,
    aData: Date | null = null): Observable<LogAccessi[]> {
    let filter = '';
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<LogAccessi[]>(this.logAccessiUrl + filter);
  }

}
